import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Improved Service Worker registration with proper error handling
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('Service Worker registered successfully:', registration.scope);
      })
      .catch(error => {
        // Only log errors that aren't expected during development
        if (!error.message.includes('Service Workers are not yet supported')) {
          console.error('Service Worker registration failed:', error);
        }
      });
  });
}

// Get the root element and ensure it exists
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found in the document');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);